import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const STATISTICS_CONFIG = enabledOn(PlatformSlug.CARSBooster, PlatformSlug.PATBooster)

export const isStatisticsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(STATISTICS_CONFIG, slug)
